import React from 'react';
import PropTypes from 'prop-types';
import { useColors } from '../../../hooks/useColors';
import { useTextReplacement } from '../../../hooks/useTextReplacement';

const TableSearchInput = ({ type, value, onChange, placeholder, className = '' }) => {
  const { semantic } = useColors();
  const { replace } = useTextReplacement();
  
  return (
    <input
      type="text"
      placeholder={placeholder || replace(`Search ${type} tables...`)}
      value={value}
      onChange={(e) => onChange(type, e.target.value)}
      className={`w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 mb-4 ${semantic.formBg} ${semantic.formText} ${semantic.formBorder} ${className}`}
      aria-label={replace(`Search ${type} tables`)}
    />
  );
};

TableSearchInput.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string
};

export default TableSearchInput;

